import { client } from 'pioneira-ui';

export default {
  namespaced: true,
  actions: {
    obterClientes() {
      return client.get('/api/simulacoes/clientes-parceiro');
    },
  },
};
